import styled from 'styled-components';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: var(--space-600);
`;
export const Description = styled.div `
  margin-bottom: var(--space-400);
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 142.857% */
  letter-spacing: var(--font-letter-spacing-loose);
`;
export const PlanOptionsContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--space-300);
`;
